export default __webpack_public_path__ + "assets/images/Payment_08.d2293e.avif";